import styled from "styled-components";
import { generic } from "../../../../../ui/_themes/constants";
import { IDialog } from "../Dialogs";

export const MessageWrapper = styled.div<IDialog>`
  font-size: ${(props: IDialog) => (props.centerMessage ? "1.2em" : "1em")};
  line-height: 1.4em;
  margin: 1.4em 0;
  color: ${generic.dialogs.content.color};
  text-align: ${(props: IDialog) =>
    props.centerMessage ? "center" : "initial"};
  overflow: ${(props: IDialog) => (props.scrollable ? "auto" : "initial")};
  flex: 1 1 auto;
  font-weight: 400;
  overflow-wrap: break-word;

  a {
    color: ${generic.dialogs.link.color};
    text-decoration: none;
  }
`;
